import { render, staticRenderFns } from "./TarefaMobilidadeAbas.vue?vue&type=template&id=612d3a07"
import script from "./TarefaMobilidadeAbas.vue?vue&type=script&lang=js"
export * from "./TarefaMobilidadeAbas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports